"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const preact_custom_element_1 = __importDefault(require("preact-custom-element"));
const download_form_1 = __importDefault(require("./components/download-form"));
(0, preact_custom_element_1.default)(download_form_1.default, 'compleat-download-form', ['id']);
